<template>
  <div class="card mt-2">
    <div class="card__title">
      <h5>Resultados de la Consulta</h5>
    </div>
    <div class="card__content">
      <div class="table-responsive">
        <table>
          <thead>
            <tr>
              <th>T. Comp.</th>
              <th>F. Emisión</th>
              <th>Vendedor</th>
              <th>Motivo</th>
              <th># Comp.</th>
              <th>Cliente/Transp.</th>
              <th>Identificación</th>
              <th>Comp. Afect./Prof.</th>
              <th v-if="conDetalles">Detalles</th>
              <th v-if="conAbonos">Abonos</th>
              <th>Tot. Sin Imp.</th>
              <th>IVA</th>
              <th>ICE</th>
              <th>IRBPNR</th>
              <th>Ret. IVA</th>
              <th>Ret. Renta</th>
              <th>Total</th>
              <th>Tot. Pagado</th>
              <th>Saldo</th>
              <th>Estado</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="registro in registros" :key="registro.id_comprobante">
              <td>{{ registro.tipo_comprobante.descripcion }}</td>
              <td>{{ registro.fecha_emision }}</td>
              <td>{{ registro.vendedor !== null?registro.vendedor.nombre:'' }}</td>
              <td>{{ registro.descripcion_motivo }}</td>
              <td>{{ registro.numero_documento }}</td>
              <td>{{ registro.cliente !== null?registro.cliente.nombre:'' }}</td>
              <td>{{ registro.numero_identificacion }}</td>
              <td>{{ registro.numeracion_comp_venta }}</td>
              <td v-if="conDetalles">
                <div class="table-responsive">
                  <table v-if="registro.id_tipo_comprobante == '07'">
                    <thead>
                      <tr>
                        <th># Doc. Sust.</th>
                        <th>F. Emi. Doc. Sust.</th>
                        <th>P. Fiscal</th>
                        <th>Cod. Ret.</th>
                        <th>B. Imponible</th>
                        <th>Impuesto</th>
                        <th>Porcentaje</th>
                        <th>Valor</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(impuesto, index) in registro.impuestos" :key="index">
                        <td>{{ impuesto.num_doc_sustento }}</td>
                        <td>{{ impuesto.fecha_emision_sustento }}</td>
                        <td>{{ impuesto.periodo_fiscal }}</td>
                        <td>{{ impuesto.id_tarifa }}</td>
                        <td>{{ moneyFormat(impuesto.base_imponible) }}</td>
                        <td>{{ impuesto.impuesto.descripcion }}</td>
                        <td>{{ moneyFormat(impuesto.tarifa) }}</td>
                        <td>{{ moneyFormat(impuesto.valor) }}</td>
                      </tr>
                    </tbody>
                  </table>
                  <table v-else-if="registro.id_tipo_comprobante == '06'">
                    <thead>
                      <tr>
                        <th># Doc.</th>
                        <th>F. Emi.</th>
                        <th># Aut.</th>
                        <th>Id. Dest.</th>
                        <th>Dest.</th>
                        <th>Mot. Traslado</th>
                        <th>Destino</th>
                        <th>Items</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(detalle, index) in registro.detalles_gr" :key="index">
                        <td>{{ detalle.num_doc_sustento }}</td>
                        <td>{{ detalle.fecha_emi_doc_sustento }}</td>
                        <td>{{ detalle.num_aut_doc_sustento }}</td>
                        <td>{{ detalle.identificacion_destinatario }}</td>
                        <td>{{ detalle.razon_social_destinatario }}</td>
                        <td>{{ detalle.motivo_traslado }}</td>
                        <td>{{ detalle.direccion_destino }}</td>
                        <td>
                          <div class="table-responsive">
                            <table>
                              <thead>
                                <tr>
                                  <th>Cod. Item</th>
                                  <th>Descripción</th>
                                  <th>Cantidad</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in detalle.items" :key="index">
                                  <td>{{ item.codigo_interno }}</td>
                                  <td>{{ item.descripcion }}</td>
                                  <td>{{ decimalFormat(item.cantidad) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table v-else>
                    <thead>
                      <tr>
                        <th>Cod. Item</th>
                        <th>Desc. Item</th>
                        <th>Cant.</th>
                        <th>P. Unit.</th>
                        <th>P. Sin Subs.</th>
                        <th>Subsidio</th>
                        <th>Descuento</th>
                        <th>P. Tot. Sin Imp.</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in registro.items" :key="index">
                        <td>{{ item.id_item }}</td>
                        <td>{{ item.descripcion_item }}</td>
                        <td>{{ decimalFormat(item.cantidad) }}</td>
                        <td>{{ moneyFormat(item.precio_unitario) }}</td>
                        <td>{{ moneyFormat(item.precio_sin_subsidio) }}</td>
                        <td>{{ moneyFormat(item.valor_subsidio) }}</td>
                        <td>{{ moneyFormat(item.descuento) }}</td>
                        <td>{{ moneyFormat(item.precio_total_sin_imp) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
              <td v-if="conAbonos">
                <div v-show="registro.abonos.length > 0" class="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th>Fecha de abono</th>
                        <th>Tipo de abono</th>
                        <th>Valor</th>
                        <th>Saldo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(abono, index) in registro.abonos" :key="abono.id">
                        <td>{{ abono.fecha_abono }}</td>
                        <td>{{ abono.descripcion_tipo_abono }}</td>
                        <td>{{ moneyFormat(abono.valor) }}</td>
                        <td>{{ moneyFormat(calcularSaldo(registro.valor_total, registro.abonos, index)) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-show="parseFloat(registro.saldo) > 0" class="table-responsive">
                  <table>
                    <thead>
                      <tr>
                        <th>Forma de pago</th>
                        <th>Plazo</th>
                        <th>Fecha máxima de pago</th>
                        <th>Diferencia de días</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        :class="{
                          'tr--canceled' : pagoExpirado(formaPago),
                          'tr--pending' : pagoExpectante(formaPago)
                        }"
                        v-for="(formaPago, index2) in registro.formas_pago"
                        :key="index2"
                      >
                        <td>{{ formaPago.forma_pago.descripcion }}</td>
                        <td>{{ formaPago.plazo }} {{ formaPago.unidad_tiempo }}</td>
                        <td>{{ formaPago.fecha_maxima_pago }}</td>
                        <td>{{ diasRestantes(formaPago) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
              <td>{{ moneyFormat(registro.total_sin_impuestos) }}</td>
              <td>{{ moneyFormat(registro.valor_iva) }}</td>
              <td>{{ moneyFormat(registro.valor_ice) }}</td>
              <td>{{ moneyFormat(registro.valor_irbpnr) }}</td>
              <td>{{ moneyFormat(registro.total_iva) }}</td>
              <td>{{ moneyFormat(registro.total_renta) }}</td>
              <td>{{ registro.anulado === 'S'?'*':'' }}{{ moneyFormat(registro.valor_total) }}</td>
              <td>{{ moneyFormat(registro.total_pagado) }}</td>
              <td>{{ moneyFormat(registro.saldo) + ' (' + (parseFloat(registro.saldo) > 0?'Pendiente':'Pagado') + ')' }}</td>
              <td>{{ registro.descripcion_estado }}</td>
              <td>
                <a
                  target="_blank"
                  :href="url + '/comprobantes/' + registro.id_comprobante + '/ride'"
                  class="btn-secondary btn--text"
                >
                  <i class="fa fa-eye"></i>
                </a>
                <a
                  v-if="registro.id_estado_comprobante === 'AUT'"
                  target="_blank"
                  :href="url + '/comprobantes/' + registro.id_comprobante + '/xml'"
                  class="btn-success btn--text"
                >
                  <i class="fa fa-file-excel-o"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <p v-if="registros.lenght === 0">
      <strong>No se ha encontrado registros en la consulta.</strong>
    </p>
  </div>
</template>
<script>
export default {
  props: {
    conAbonos: {
      type: Boolean,
      required: false,
      default: false,
    },
    conDetalles: {
      type: Boolean,
      required: false,
      default: false,
    },
    registros: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    diasAlerta: {
      required: false,
      default: 0
    }
  },
  data: function () {
    return {
      moneyFormat: moneyFormat,
      url: url,
      decimalFormat: decimalFormat,
    };
  },
  methods: {
    pagoExpirado: function (formaPago) {
      let dateInicial = moment(new Date());
      let dateFinal = moment(
        new Date(formaPago.fecha_maxima_pago + " 00:00:00")
      );
      let diferencia = dateFinal.diff(dateInicial, "days") + 1;
      return diferencia < 0;
    },
    pagoExpectante: function (formaPago, fechaEmision) {
      let dateInicial = moment(new Date());
      let dateFinal = moment(
        new Date(formaPago.fecha_maxima_pago + " 00:00:00")
      );
      let diferencia = dateFinal.diff(dateInicial, "days") + 1;
      return diferencia < this.diasAlerta;
    },
    diasRestantes: function (formaPago) {
      let dateInicial = moment(new Date());
      let dateFinal = moment(
        new Date(formaPago.fecha_maxima_pago + " 00:00:00")
      );
      let diferencia = dateFinal.diff(dateInicial, "days") + 1;
      return diferencia;
    },
    calcularSaldo: function (total, abonos, index) {
      let saldo = parseFloat(total);
      for (let i = 0; i <= index; i++) saldo -= parseFloat(abonos[i].valor);
      return round(saldo);
    },
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/TablaReporteVentas.vue